// Ionic Angular
import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "tidy-card-indicator",
    styleUrls: ['./tidy-card-indicator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
  <div class="tidy-container">
    <div class="tidy-item">
        <ng-content select="[item-left]"></ng-content>
    </div>
    <div class="tidy-item tidy-indicator">
      <ng-content select="[item-right]"></ng-content>
    </div>
  </div>
  `,
    standalone: false
})
export class TidyCardIndicator {}
